import { render, staticRenderFns } from "./CheckListRegister.vue?vue&type=template&id=04efff78&"
import script from "./CheckListRegister.vue?vue&type=script&lang=js&"
export * from "./CheckListRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports